// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__GgfG8","before":"Hero_before__fazP1","video":"Hero_video__jD6N3"};